import React from "react";

// Official SSG AI logo. Master source: /public/logo.png
export const Logo = ({ size = 40, className = "" }) => (
  <img
    src="/logo.png"
    alt="SSG AI"
    width={size}
    height={size}
    className={`rounded-xl object-contain shrink-0 ${className}`}
    style={{ width: size, height: size }}
  />
);

export default Logo;
